import React, { useEffect } from 'react';
import { Typography, Divider, Grid, Avatar, withWidth, Button } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { API_KEYS, getApiResource, getUIProperty } from '../../reducers';
import { apiGET, setUIProperty, setLocation } from '../../actions';
import { compose, withDispatch, withLifecycle, withState } from '../../enhancers';
import ErrorBoundary from './ErrorBoundary';
import Link from '../generic/Link';
import { ReactComponent as Steps } from '../../styles/images/steps.svg';
import defaultLogo from '../../styles/images/templates/CreateYourOwn.png';
import './exhibitionOfTheMonth.css';

/*
Adobe XD WireFrames:
Desktop: https://xd.adobe.com/view/119550ba-53d6-4873-4d2d-4274b214146d-67a4/screen/b221bbf9-0c5c-4318-a977-b09353e20d00/specs/
Mobile/responsive: https://xd.adobe.com/view/28029a38-e79b-4dc6-661c-350343733a8f-5e33/screen/59de4c92-8076-43f6-b231-de20dbdd5ce0/specs/
 */

/* TODO: Make the trim a utils function so that after passing the limit it can do the trim **Probably to the closest end of sentence** and add the '...' at the end. */
const trimText = (text, size) => {
  try {
    return text.substring(0, size).concat(text.length > size ? '...' : '');
  } catch (e) {
    return '';
  }
};

export const ExhibitionOfTheMonthView = ({
  exhibitions = [],
  user = {},
  width,
  isPrivateSpace,
  blocked,
}) => {
  const [run, setRun] = React.useState(false);

  useEffect(() => {
    if (exhibitions.length === 0 || isPrivateSpace === true || blocked === true) {
      setRun(false);
      return;
    }
    try {
      // eslint-disable-next-line no-unused-vars
      const previewUrl = exhibitions[0].image.preview;
      // eslint-disable-next-line no-unused-vars
      const tmp = exhibitions[0].title;
      // eslint-disable-next-line no-unused-vars
      const currentUsername = user.profile.name;

      /* // for localhost only
      exhibitions[0].image.preview =
        'https://files.artsteps.com/users/5ed3b003ea6d3006113acd59/et_5f915e7b34ae3770e96ae0f6_1604429537626.jpg'; */

      fetch(previewUrl, {
        method: 'GET',
      })
        .then(response => {
          if (response.status !== 200) {
            // eslint-disable-next-line no-param-reassign
            exhibitions[0].image.preview = defaultLogo;
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-param-reassign
          exhibitions[0].image.preview = defaultLogo;
        });

      setRun(true);
    } catch (e) {
      setRun(false);
    }
  }, [user, exhibitions, blocked, isPrivateSpace]);

  if (run) {
    return (
      <div className="main-div">
        <Typography gutterBottom className="main-text-main-title">
          <strong>Exhibition of the Month</strong>
        </Typography>
        <Divider className="divider" />
        <Grid
          container
          direction={width === 'md' || width === 'lg' || width === 'xl' ? 'row' : 'column'}
          justify={width === 'md' || width === 'lg' || width === 'xl' ? 'flex-start' : 'center'} // was 'space-between' : 'center'
          alignItems={width === 'md' || width === 'lg' || width === 'xl' ? 'flex-end' : 'stretch'} // flex-start -> stretch
          spacing={width === 'md' || width === 'lg' || width === 'xl' ? 4 : 2}
          wrap="nowrap"
        >
          <Grid item>
            <ErrorBoundary>
              {exhibitions[0].image.preview ? (
                <Link to={`/view/${exhibitions[0]._id}`}>
                  <img
                    alt={exhibitions[0].title}
                    src={exhibitions[0].image.preview}
                    className="preview-image"
                  />
                </Link>
              ) : (
                <Skeleton variant="rect" />
              )}
            </ErrorBoundary>
          </Grid>
          <Grid item>
            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
              <Grid item>
                <ErrorBoundary>
                  <Avatar
                    alt="Exhibition of the month avatar"
                    src={user.profile.image.preview}
                    className="icon-avatar"
                  />
                </ErrorBoundary>
              </Grid>
              <Grid item>
                <ErrorBoundary>
                  <Typography gutterBottom className="main-text-username">
                    <strong>{user.profile.name}</strong>
                  </Typography>
                </ErrorBoundary>
              </Grid>
            </Grid>
            <Typography variant="h6" gutterBottom className="main-text">
              DIGITAL EXHIBITION
            </Typography>
            <ErrorBoundary>
              <Typography
                variant={width === 'xl' ? 'h5' : 'h5'}
                gutterBottom
                className="main-text-title"
              >
                {exhibitions[0].title}
              </Typography>
            </ErrorBoundary>
            <ErrorBoundary>
              <Typography gutterBottom className="main-text-description">
                {width === 'md'
                  ? trimText(exhibitions[0].description, 128)
                  : trimText(exhibitions[0].description, 256)}
                {/* Designer requested a limit on this text's length. */}
              </Typography>
            </ErrorBoundary>
            <br />
            <ErrorBoundary>
              <Link to={`/view/${exhibitions[0]._id}`}>
                <Button className="more-button" endIcon={<Steps />}>
                  Step Inside
                </Button>
              </Link>
            </ErrorBoundary>
          </Grid>
        </Grid>
      </div>
    );
  }
  return <></>;
};

const query = {
  filter: {
    published: true,
    staffPick: true,
  },
  populate: ['user'],
  include: [
    'categories',
    'description',
    `views.${API_KEYS.META}.totalCount`,
    `likes.${API_KEYS.META}.totalCount`,
    'visits',
    'rating',
    '_v1Rating',
    'staffPick',
  ],
};
const createQuery = ({ filter, limit, offset, sort, include, populate }) => ({
  filter,
  sort,
  page: { limit, offset },
  include,
  populate,
});

const mapState = state => ({
  exhibitions: getUIProperty(state, 'ExhibitionOfTheMonthExhibition'),
  categoryList: getApiResource(state, `categories`),
  user: getUIProperty(state, `ExhibitionOfTheMonthUser`),
  isPrivateSpace: getUIProperty(state, 'isPrivateSpace'),
  blocked: getUIProperty(state, 'ExhibitionOfTheMonthBlocked'),
});
const mapDispatch = dispatch => ({
  onRedirect: location => dispatch(setLocation(location)),
  onFetchExhibitionAndUser: () => {
    dispatch(apiGET('exhibitions', createQuery(query)))
      .then(({ response: responseExhibition }) => {
        if (!responseExhibition) {
          dispatch(setUIProperty('ExhibitionOfTheMonthBlocked', true));
        } else {
          dispatch(
            setUIProperty(
              'ExhibitionOfTheMonthExhibition',
              Object.values(responseExhibition),
              true,
            ),
          );
          dispatch(apiGET(`users/${Object.values(responseExhibition)[0].user._id}`))
            .then(({ response: responseUser }) => {
              if (!responseUser) {
                dispatch(setUIProperty('ExhibitionOfTheMonthBlocked', true));
              } else {
                dispatch(setUIProperty('ExhibitionOfTheMonthUser', responseUser));
                dispatch(setUIProperty('ExhibitionOfTheMonthBlocked', false));
              }
            })
            .catch(error => {
              dispatch(setUIProperty('ExhibitionOfTheMonthBlocked', true));
            });
        }
      })
      .catch(error => {
        dispatch(setUIProperty('ExhibitionOfTheMonthBlocked', true));
      });
  },
});

const onInitialization = ({ onFetchExhibitionAndUser }) => {
  onFetchExhibitionAndUser();
};

const lifecycleMap = {
  onDidMount: props => onInitialization(props),
};
const ExhibitionOfTheMonth = compose(
  withState(mapState),
  withDispatch(mapDispatch),
  withLifecycle(lifecycleMap),
  withWidth(),
)(ExhibitionOfTheMonthView);
export default ExhibitionOfTheMonth;
